// extracted by mini-css-extract-plugin
export default {"prismicTest":"PrismicDevTestContainer-module_prismicTest__HKcoG"};